import * as angular from 'angular';
import {IController} from "angular";

export class OperationLinkCtrl implements IController {
  serviceId: string;
  externalId: string;
  priorityId: string;
  showTooltip: boolean;

  public canCopy: boolean;
  private displayExternal: any;
  private displayId: any;

  /* @ngInject */
  constructor(private splitService) {
    this.displayExternal = this.splitService.getSiteExternalIdConfig()
  }

  $onInit() {
    this.displayId = this.priorityId ? this.priorityId : (!this.externalId ?
        this.serviceId : (this.displayExternal ? this.externalId : this.serviceId)
    );
  };

  $onChanges(changes) {
    if (changes.serviceId && !changes.serviceId.isFirstChange() ||
      changes.externalId && !changes.externalId.isFirstChange()) {
      this.$onInit();
    }
  };


}

angular
  .module('bringoz.admin.deliveries')
  .component('operationLink', {
    bindings: {
      serviceId: '<',
      externalId: '<?',
      priorityId: '<?',
      showTooltip: '<?'
    },
    template: require('./operation-link.html').default,
    controller: OperationLinkCtrl
  });
